'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' });

var OfflinePin = function OfflinePin(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

OfflinePin = (0, _pure2.default)(OfflinePin);
OfflinePin.muiName = 'SvgIcon';

exports.default = OfflinePin;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/OfflinePin.js
// module id = 2657
// module chunks = 0